import PropTypes from "prop-types";
import React, { useCallback, useContext, useEffect, useState } from "react";



import styled from "styled-components/macro";

import API from "Signups/API";
import { SignupsAppState } from "Signups/state.js";
import { AnimatePresence, motion } from "framer-motion";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

import useComponentIsMounted from "Utilities/Hooks/useComponentIsMounted";

// import "./SignupOption.scss";

SignupOption.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  on: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  customValue: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  customOptionName: PropTypes.string,
  customDispatchName: PropTypes.string,
};

export default function SignupOption({
  text,
  name,
  on = false,
  disabled = false,
  customValue,
  customOptionName,
  customDispatchName,
  children,
}) {
  const [
    {
      currentSignupList: { ID: signupListID },
    },
    dispatch,
  ] = useContext(SignupsAppState);

  const [stagedOn, setStagedOn] = useState(on);
  const [loading, setLoading] = useState(false);
  const [prevCustomValue, setPrevCustomValue] = useState(customValue);

  const isUpdatingCustomValue =
    on &&
    Boolean(customValue) &&
    Boolean(prevCustomValue) &&
    customValue !== prevCustomValue;

  const editOption = useCallback(() => {
    setLoading(true);
    if (!isUpdatingCustomValue) {
      setStagedOn((currStagedOn) => !currStagedOn);
    }

    const optionName = customOptionName ?? name;
    const isTogglingOnCustomValue = customValue && !on;

    const postData = {
      optionName,
      value:
        isTogglingOnCustomValue || isUpdatingCustomValue ? customValue : !on,
    };

    API.editSignupListOption(signupListID, postData)
      .then((res) => {
        const value = res.options[optionName];
        setStagedOn(value > 0);
        dispatch({
          type: "Edit Signup List Option",
          name: customDispatchName ?? optionName,
          value,
        });
      })
      .catch((e) => {
        console.error(
          `Received error while attempting to Edit Signup List Option: ${e.message}`
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    customDispatchName,
    customOptionName,
    customValue,
    dispatch,
    isUpdatingCustomValue,
    name,
    on,
    signupListID,
  ]);

  useEffect(() => {
    if (!isUpdatingCustomValue) return;

    editOption();
  }, [editOption, isUpdatingCustomValue]);

  useEffect(() => {
    setPrevCustomValue(customValue);
  }, [customValue]);

  // <Wrapper onClick={(e) => e.preventDefault()}>
  return (
    <Wrapper>
      <CheckboxHolder>
        <FnrCheckbox
          on={stagedOn}
          toggleOn={editOption}
          loading={loading}
          disabled={disabled}
        >
          <Text>{text}</Text>
        </FnrCheckbox>
      </CheckboxHolder>
      {children && <ChildrenHolder>{children}</ChildrenHolder>}
    </Wrapper>
  );
}

// TODO follow up with styles from SignupOption.scss not being applied - does this just happen in dev?
const Wrapper = styled.div`
  margin-bottom: 20px;

  // from SignupOption.scss (wasn't getting applied)
  //.react-datepicker-wrapper {
  //margin-top: 8px;
  //margin-left: 23px;
  //}

  .react-datepicker__input-container input {
    padding: 2px 2px 2px 7px;
    color: #15436a;
    font-family: "Open Sans", sans-serif;
    border-radius: 5px;
    border: 1px solid #bec3c7;
  }

  .react-datepicker-popper {
    //width: 330px;
    z-index: 501;
  }
`;
const CheckboxHolder = styled.div`
  //position: relative;
  //z-index: 10;
`;
const ChildrenHolder = styled.div`
  padding-left: 35px;
  //position: relative;
  //z-index: 5;
`;

const Text = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SignupSubOption = ({ show, children }) => {
  const isMounted = useComponentIsMounted();

  const visible = {
    opacity: 1,
    height: "auto",
    y: 0,
  };
  const hidden = {
    opacity: 0,
    height: 0,
    y: -20,
  };

  return (
    <AnimatePresence>
      {show && (
        <AnimateOptionWrapper
          initial={show && !isMounted ? visible : hidden}
          animate={visible}
          exit={{
            ...hidden,
            y: -14,
            transition: {
              type: "tween",
              duration: 0.3,
              ease: "backIn",
            },
          }}
        >
          <AnimateOptionInside>{children}</AnimateOptionInside>
        </AnimateOptionWrapper>
      )}
    </AnimatePresence>
  );
};

const AnimateOptionWrapper = styled(motion.div)`
  .react-datepicker__tab-loop {
    display: inline-block;
  }
`;
const AnimateOptionInside = styled.div`
  padding-top: 12px;
`;